import { Reveal } from "./Reveal";

const OPERATES = [
    "We pool our members into a single buying consortium. Bulk, fleet, and consortium purchasing gives us leverage no individual buyer has — and we use it to allocate factory-fresh 2026 RAV4s with Factory Installed Options only.",
    "Every allocation is guaranteed within 90 days or refunded in full, and every vehicle lands below Total Suggested Retail Price — even after our one-time $399 fee.",
];

const BELIEFS = [
    "The dealership model is less than ideal.",
    "Consumers deserve honesty and transparency.",
    "Consortium buying gives consumers leverage.",
    "Dealers are entitled to a profit — not an exorbitant, excessive profit.",
    "Add-ons — whether DIO, LIO, or Distributor IOs — inflate the vehicle cost and result in losses upon resale.",
    "Consumers deserve financing based on their actual credit worthiness, without the interest rate being marked up.",
    "Toyota is one of the best automobile manufacturers in the world.",
    "Acquiring your vehicle should be quick and easy.",
];

export const Beliefs = () => (
    <section
        id="beliefs"
        data-testid="beliefs-section"
        className="border-t border-white/10 py-28 sm:py-36"
    >
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-6 lg:grid-cols-12">
            <Reveal className="lg:col-span-5">
                <p className="mb-4 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.35em] text-[#2563EB]">
                    <span className="h-2 w-2 rotate-45 bg-[#2563EB]" aria-hidden="true" />
                    Our principles
                </p>
                <h2 className="font-display text-3xl font-extrabold uppercase leading-[1.02] tracking-tighter sm:text-5xl">
                    How the club operates and what we believe.
                </h2>
                <div className="mt-8 space-y-5">
                    {OPERATES.map((p, i) => (
                        <p
                            key={i}
                            className="text-base leading-relaxed text-zinc-400 md:text-lg"
                        >
                            {p}
                        </p>
                    ))}
                </div>
            </Reveal>

            <div className="lg:col-span-7">
                <ol data-testid="beliefs-list" className="divide-y divide-white/10">
                    {BELIEFS.map((belief, i) => (
                        <Reveal key={i} delay={i * 0.06}>
                            <li
                                data-testid={`belief-${i + 1}`}
                                className="group flex items-baseline gap-6 py-6"
                            >
                                <span className="font-display text-sm font-extrabold tracking-widest text-[#2563EB] transition-colors duration-300">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                                <p className="font-display text-lg font-bold uppercase leading-snug tracking-tight text-zinc-200 transition-colors duration-300 group-hover:text-white sm:text-xl">
                                    {belief}
                                </p>
                            </li>
                        </Reveal>
                    ))}
                </ol>
            </div>
        </div>
    </section>
);
